module.exports = __webpack_public_path__ + "assets/img/title-9202d03e.png";